import * as React from "react";
const SvgStage = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M15.22 4.22a.75.75 0 0 1 .53-.22h4.5c.966 0 1.75.784 1.75 1.75v12.5A1.75 1.75 0 0 1 20.25 20h-3.5a.75.75 0 0 1-.75-.75c0-2.499.593-4.193 1.226-5.283.21-.36.421-.651.613-.881-1.157-.912-1.88-1.896-2.299-3.125C15.056 8.544 15 6.86 15 4.75a.75.75 0 0 1 .22-.53Zm4.197 9.403.002-.001.003-.002.002-.001m-.006.004h-.001ZM16.503 5.5c.018 1.736.113 2.97.457 3.976.371 1.09 1.058 1.968 2.456 2.9a.75.75 0 0 1 .007 1.243l-.004.003a2.483 2.483 0 0 0-.236.212c-.17.174-.412.46-.66.886-.434.75-.9 1.955-1.003 3.78h2.73a.25.25 0 0 0 .25-.25V5.75a.25.25 0 0 0-.25-.25h-3.747Z"
      fill="currentColor"
    />
    <path
      d="M13.017 4.25a.75.75 0 0 0-.766.734L13 5l-.75-.016v.107a14.93 14.93 0 0 0 .062 1.228c.07.782.225 1.84.564 2.908.337 1.062.871 2.186 1.732 3.052.88.885 2.074 1.471 3.637 1.471a.75.75 0 0 0 0-1.5c-1.146 0-1.962-.414-2.573-1.029-.63-.634-1.069-1.51-1.366-2.448a12.522 12.522 0 0 1-.502-2.591 13.506 13.506 0 0 1-.055-1.151v-.015m-.733-.766a.75.75 0 0 1 .734.766l-.734-.766ZM11.23 4.25a.75.75 0 0 1 .765.734l-.75.016.75-.016v.107c0 .064 0 .157-.003.273-.007.232-.022.56-.058.954-.071.783-.226 1.84-.565 2.909-.337 1.062-.871 2.186-1.732 3.052-.88.885-2.074 1.471-3.637 1.471a.75.75 0 0 1 0-1.5c1.146 0 1.962-.414 2.573-1.029.63-.634 1.069-1.51 1.366-2.448.296-.931.436-1.874.502-2.591a13.568 13.568 0 0 0 .055-1.093V5.016m.733-.766a.75.75 0 0 0-.734.766l.734-.766Z"
      fill="currentColor"
    />
    <path
      d="M8.997 5.5h6.753a.75.75 0 1 0 0-1.5h-12A1.75 1.75 0 0 0 2 5.75v12.5c0 .966.784 1.75 1.75 1.75h3.5a.75.75 0 0 0 .75-.75c0-2.499-.593-4.193-1.226-5.283a6.32 6.32 0 0 0-.613-.881c1.157-.912 1.88-1.896 2.299-3.125.425-1.245.52-2.697.537-4.461Zm-5.247 0h3.747c-.018 1.736-.113 2.97-.457 3.976-.371 1.09-1.058 1.968-2.456 2.9a.75.75 0 0 0-.008 1.243l.004.003.042.032c.042.034.11.093.194.18.17.174.413.46.66.886.436.75.901 1.955 1.004 3.78H3.75a.25.25 0 0 1-.25-.25V5.75a.25.25 0 0 1 .25-.25ZM18.272 12.818a.75.75 0 0 1 .91-.546l2 .5a.75.75 0 1 1-.364 1.456l-2-.5a.75.75 0 0 1-.546-.91Z"
      fill="currentColor"
    />
    <path
      d="M5.728 12.818a.75.75 0 0 0-.91-.546l-2 .5a.75.75 0 0 0 .364 1.456l2-.5a.75.75 0 0 0 .546-.91Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgStage;
